import UENValidators from "@/constants/UENValidator/index.json";

function validateUEN(val, country) {
	let rules;
	if (country in UENValidators) {
		rules = UENValidators[country].uen;
	} else {
		rules = UENValidators["default"].uen;
	}
	if ("minLength" in rules && val.length < rules.minLength) {
		return false;
	}
	if ("maxLength" in rules && val.length > rules.maxLength) {
		return false;
	}
	return !("format" in rules && !new RegExp(rules.format).test(val));
}


export const validatePrincipalUEN = (val) => {
	return /^[a-zA-Z0-9]+$/.test(val);
}

export default validateUEN;